function PaymentsCentralTable(){
  return (
    <div>
      
    </div>
  )
}

export default PaymentsCentralTable;